export const ALL_PLAN_FEATURES = [
  "Home",
  "Student",
  "Attendance",
  "Inventory",
  "Time Table",
  "MDM",
  "Result",
  "Fee",
  "Account",
  "Payroll"
];

export const SUBSCRIPTION_PLANS = [
  {
    name: "Free Trial",
    studentLimit: 20,
    price: 0,
    durationDays: 7,
    includedFeatures: [
      "7 Days Full Access",
      "Up to 20 Students Limit",
      "Student Record & Registration",
      "Bonafide Certificate Generation",
      "Leaving Certificate (LC / TC)",
      "No Payment / Card Required"
    ]
  },
  {
    name: "100 Students Plan",
    studentLimit: 100,
    price: 5000,
    includedFeatures: [
      "Up to 100 Students Limit",
      "Student Record & Registration",
      "Bonafide Certificate Generation",
      "Leaving Certificate (LC / TC)",
      "Student Identity Cards",
      "Standard Reports & Export"
    ]
  },
  {
    name: "250 Students Plan",
    studentLimit: 250,
    price: 10000,
    includedFeatures: [
      "Up to 250 Students Limit",
      "Student Record & Registration",
      "Bonafide Certificate Generation",
      "Leaving Certificate (LC / TC)",
      "Student Identity Cards",
      "Standard Reports & Export"
    ]
  },
  {
    name: "500 Students Plan",
    studentLimit: 500,
    price: 15000,
    includedFeatures: [
      "Up to 500 Students Limit",
      "All Basic Features",
      "Fee Management & Receipts",
      "Daily Student Attendance",
      "Staff & Teacher Attendance",
      "Fee Due SMS & Notifications"
    ]
  },
  {
    name: "750 Students Plan",
    studentLimit: 750,
    price: 20000,
    includedFeatures: [
      "Up to 750 Students Limit",
      "All 500 Plan Features",
      "Exam & Marksheet System",
      "Progress Report Card Generator",
      "Daily Attendance & SMS",
      "Standard & Custom Reports"
    ]
  },
  {
    name: "1000 Students Plan",
    studentLimit: 1000,
    price: 25000,
    includedFeatures: [
      "Up to 1000 Students Limit",
      "All 750 Plan Features",
      "Exam & Marksheet System",
      "Class Rank & Analytics",
      "Custom Report Templates",
      "Priority Technical Support"
    ]
  },
  {
    name: "1500 Students Plan",
    studentLimit: 1500,
    price: 35000,
    includedFeatures: [
      "Up to 1500 Students Limit",
      "All Advanced Features",
      "Poshanahar (Midday Meal) Reports",
      "Daily Meal Inventory & Stock",
      "Government Compliance Export",
      "Priority Dedicated Support"
    ]
  },
  {
    name: "2000 Students Plan",
    studentLimit: 2000,
    price: 45000,
    includedFeatures: [
      "Up to 2000 Students Limit",
      "Complete All-in-One School Suite",
      "Full Poshanahar (Midday Meal) System",
      "Custom Report Templates",
      "Government Compliance Export",
      "24/7 Dedicated Priority Support"
    ]
  }
];

export const PAID_PLANS = SUBSCRIPTION_PLANS.filter((plan) => plan.studentLimit > 20);
export const FREE_TRIAL_PLAN = SUBSCRIPTION_PLANS[0];

export const normalizePlanPrices = (savedPlans = {}) =>
  Object.fromEntries(
    SUBSCRIPTION_PLANS.map((plan) => [
      plan.name,
      {
        studentLimit: plan.studentLimit,
        durationDays: plan.durationDays || 365,
        mrp: savedPlans?.[plan.name]?.mrp ?? plan.price,
        includedFeatures: plan.includedFeatures
      }
    ])
  );
